import * as React from 'react'

export const UserForm = (props) => {
    return (
        <Layout>
            This will the User form for collecting additioal user data.
        </Layout>
    )
}
